import { useState } from "react";
import { PageHeader } from "../components/shared";
import ShopifySettings from "../components/ShopifySettings";
import WebhookLog from "../components/WebhookLog";
import TrackingSettings from "../components/TrackingSettings";
import EmailSettings from "../components/EmailSettings";

const TABS = [
  { id: "log", label: "Webhook Log", C: WebhookLog },
  { id: "settings", label: "Shopify", C: ShopifySettings },
  { id: "tracking", label: "Carrier Tracking", C: TrackingSettings },
  { id: "email", label: "Email", C: EmailSettings },
];

export default function Shopify() {
  const q = new URLSearchParams(window.location.search).get("tab");
  const [tab, setTab] = useState(TABS.some((t) => t.id === q) ? q : "log");
  const Active = TABS.find((t) => t.id === tab).C;
  return (
    <div>
      <PageHeader kicker="// ADMIN · CONNECTIONS" title="Integrations">
        {TABS.map((t) => (
          <button key={t.id} data-testid={`shopify-tab-${t.id}`} onClick={() => setTab(t.id)}
            className={`h-12 px-5 rounded-md text-sm font-semibold border ${tab === t.id ? "bg-white text-[#090D16]" : "border-[#334155] text-[#9CA3AF]"}`}>{t.label}</button>
        ))}
      </PageHeader>
      <Active />
    </div>
  );
}
